import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { IOvhCatalogAPI } from "types/api/ovhApiInterface";

import MailboxProBox from "../MailboxProBox";
import ServerTypeBox from "../ServerTypeBox";

import OvhOsSection from "./OvhOsSection";

const OTypeAndOs = ({
 description,
 serverType,
 serverCode,
 osOvh,
 ovhCatalog,
 mailboxProNumber,
 setData
}: {
 description: string;
 serverType: string;
 serverCode: string;
 osOvh: string;
 ovhCatalog: Array<IOvhCatalogAPI>;
 mailboxProNumber: number;
 setData: (section: string, value: string | number | boolean) => void;
}): ReactElement => {
 const handleSetServer = (type: string) => {
  setData("serverType", type);
  if (type !== "custom") {
   setData("osOvh", "Debian 12");
  }
 };

 return (
  <Paper elevation={1} sx={{ borderRadius: "5px", p: 2, textAlign: "left" }}>
   <Typography variant="unboundedTitle" fontSize={18}>
    <FormattedMessage id="server.add.selectServerType" />
   </Typography>
   <Stack spacing={2} mt={2}>
    <Typography textAlign="left" variant="subtitle2">
     <FormattedMessage id={description} />
    </Typography>
    <Stack>
     <Typography variant="unboundedTitle" sx={{ fontSize: 16 }}>
      Custom
     </Typography>
     {serverCode === "" ? (
      <Typography variant="subtitle2">
       <FormattedMessage id="server.add.selectSizeToViewOs" />
      </Typography>
     ) : (
      <OvhOsSection
       selectedOs={osOvh}
       osList={ovhCatalog.find((element) => element.planCode === serverCode)?.os || []}
       selectOs={(value) => {
        setData("osOvh", value || "");
       }}
      />
     )}
    </Stack>
    <Stack>
     <Typography variant="unboundedTitle" sx={{ fontSize: 16 }}>
      Management
     </Typography>
     <ServerTypeBox
      provider="ovh"
      selectedType={serverType}
      selectType={(type) => handleSetServer(type || "")}
     />
    </Stack>
    {serverType === "container-mail-pro" && (
     <Stack>
      <Typography variant="unboundedTitle" sx={{ fontSize: 16 }}>
       PRO config
      </Typography>
      <MailboxProBox
       selectedNumber={mailboxProNumber}
       selectNumber={(value) => setData("mailboxPro", value)}
      />
     </Stack>
    )}
   </Stack>
  </Paper>
 );
};

export default OTypeAndOs;
